<template>
    <div class="page-wrapper" ref="five">
        <!-- 顶部图片 -->
        <div class="movie-box banner-wrapper">
            <img class="page-image" src="@assets/images/summer-img-3.png" />
        </div>

        <div class="movie-box festivalList-wrapper">
        <!-- nav -->
        <div class="movie-box acea-row row-middle nav-wrapper"  ref="nav">
            <FestivalNav v-if="!mounting" @checkNav="checkNav" :isless="true" :boxStyle="boxStyle" :liStyle="liStyle" :current="current" :navList="navList"></FestivalNav>
        </div>

        <div class="movie-box acea-row row-middle nav-wrapper mounting" v-show="mounting">
            <FestivalNav @checkNav="checkNav" :isless="true" :boxStyle="boxStyle" :liStyle="liStyle" :current="current" :navList="navList"></FestivalNav>
        </div>
        
        <!-- 模板 -->
        <div class="movie-box" v-for="(item, ind) in list" :key="ind" :ref="'modul'+item.id">
            <FestivalModul :cardOne="cardOne" :titleInfo="item.titleInfo" :bottomPrice="bottomPrice" :imgStyle="imgStyle" :listStyle="listStyle" :festivalName="festivalName" :list="item.list"></FestivalModul>
        </div>

        <!-- 底部 -->
        <div class="movie-box page-relative">
            <img class="page-image" src="@assets/images/summer-backgroung_bottom.png" />
            <img class="page-absolute got" @click="goBack" src="@assets/images/summer-goBack.png" />
        </div>
        </div>
        <!-- 回到顶部 -->
        <img src="@assets/images/summer-goTop.png" class="page-fixed goTop" @click="goTo"  />
    </div>
</template>

<script>
import FestivalModul from "@components/FestivalModul.vue";
import FestivalNav from "@components/FestivalNav.vue";
import debounce from "lodash.debounce";
export default {
    name: "Summer",
    components: {
        FestivalModul,
        FestivalNav
    },
    data: function () {
        return {
            mounting: false,
            festivalName: 2,//专题标识
            listStyle: {
                background: `url(${require('@assets/images/summer-data-banner.png')}) no-repeat`,
                "background-size":"cover",
                padding:".19rem",
                "border-radius":".3rem"
            },
            boxStyle: {
                "justify-content": "center"
            },
            liStyle: {
                width: "1.8rem",
                margin: "0rem"
            },
            imgStyle: {
                "height": "2.4rem",
                margin: ".1rem 0"
            },
            cardOne: {
                "border-radius": "0.3rem"
            },
            bottomPrice: {
                priceStyle: {
                    "color": "c10125",
                    "font-size": "0.4rem",
                    "font-weight": "500"
                },
                imgStyle: {
                    "width": "0.52rem",
                    "height": "0.52rem"
                },
                src: `${require('@assets/images/summer-buy.png')}`,
                iconStyle: {
                    "display":"none"
                },
                front: {
                    "color": "c10125",
                    "font-size": "0.3rem",
                    "display": "inline !important"
                },
                wrapStyle: {
                    
                },
                dd: {
                    "padding": "0 0 0.15rem",
                    "align-items": "center"
                }
            },
            navList: [
                {
                    id: 1,
                    img: require("@assets/images/summer-nav1-1.png"),
                    checkImg: require("@assets/images/summer-navc11.png")
                }, {
                    id: 2,
                    img: require("@assets/images/summer-nav2-1.png"),
                    checkImg: require("@assets/images/summer-navc22.png")
                }, {
                    id: 3,
                    img: require("@assets/images/summer-nav3-1.png"),
                    checkImg: require("@assets/images/summer-navc33.png")
                }, {
                    id: 4,
                    img: require("@assets/images/summer-nav4-1.png"),
                    checkImg: require("@assets/images/summer-navc44.png")
                }
            ],
            list: [
                {
                    id: 1,
                    titleInfo: require("@assets/images/summer-title1-1.png"),
                    list: [
                    {
                        image: "http://gzh.xiaojiangwh.com/uploads/attach/2020/04/20200423/b2856c87ac644b6c37175551989e909b.jpg",
                        title: "意大利 圣培露气泡水 250mlx24瓶 玻璃瓶整箱",
                        price: 136.00,
                        id: 31
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220516/fb0b43bf42187bd447ca432ec37ef58c.jpg",
                        title: "法国原装进口 Perrier巴黎水柠檬味气泡水 330mx24 玻璃瓶 整箱装",
                        price: 145.00,
                        id: 178134
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220516/5eb032b2dca28d2b4912db3f1a07af97.jpg",
                        title: "法国进口evian依云天然矿泉玻璃瓶 330ml*20整箱",
                        price: 196.00,
                        id: 178135
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220516/a0a71683ba5e10e4db72ea3f609e7052.jpg",
                        title: "百岁山饮用天然矿泉水 570mlx24瓶 整箱装（新老包装随机发）",
                        price: 62.00,
                        id: 178136
                    }, {
                        image: "https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/shop/2021-06-02/741f9ef0781005866a5606c4f0c2915c.jpg",
                        title: "统一 爱夸 长白山 天然矿泉水 即饮装 570mlx15",
                        price: 59.90,
                        id: 8812
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220516/d0d50b6a99d5d861ee9193f8614ccced.jpg",
                        title: "农夫山泉 饮用天然雪山矿泉水长白雪 535mlx24瓶（图案随机）",
                        price: 69.90,
                        id: 178138
                    }, {
                        image: "http://gzh.xiaojiangwh.com/uploads/attach/2020/04/20200423/8eab1a03d9531589f4b9bdefa0fe471e.jpg",
                        title: "景田 纯净水/天然泉水 560mlx24瓶 整箱装",
                        price: 41.90,
                        id: 25
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220516/a6b9dcbf3f4c8411d95fc599db6c9a85.jpg",
                        title: "元气森林苏打气泡水480ml*15瓶 白桃味",
                        price: 86.90,
                        id: 178141
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220516/9d9b66bedbcf1d65344e8a49e5cd8b86.jpg",
                        title: "元气森林 无蔗糖低脂肪乳茶 450ml*12瓶 原味",
                        price: 128.00,
                        id: 178145
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220516/bcacacd743872991afb3c91129f086e6.jpg",
                        title: "信远斋酸梅汤 300ml*12瓶",
                        price: 69.90,
                        id: 178149
                    }, {
                        image: "http://gzh.xiaojiangwh.com/uploads/attach/2020/04/20200423/2dd84543cb700d24b52905d158f80ba2.jpg",
                        title: "燕京至简苏打水 380mlx24瓶 整箱装",
                        price: "51.90",
                        id: 23
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220516/b3ca9c78f5fb06ab371bf92864baa4f8.jpg",
                        title: "加多宝 凉茶植物饮料 茶饮料 310mlx24罐 整箱装",
                        price: 67.90,
                        id: 178156
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2021/05/20210524/664736f32ccb676dcfd47ff77560117f.jpg",
                        title: "杨协成马蹄爽300mlx24罐",
                        price: 118.00,
                        id: 7056
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2020/04/20200421/c0574d4e8e44f80462d9b33bf9a06c09.jpg",
                        title: "泰国进口 象牌苏打水 325mlx24瓶 整箱",
                        price: 125.00,
                        id: 24
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/f95e06c038656f140f3c0718411c7bbe.jpg",
                        title: "北冰洋 橙汁味汽水 碳酸饮料 330ml*24听/箱 家庭装",
                        price: 128.00,
                        id: 178063
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220516/be2471a1eaad6706f7196522f8acced5.jpg",
                        title: "美恩奇亚籽290mlx24混合口味",
                        price: 165.00,
                        id: 178158
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220516/9168303b785fda15a3d114831f1d6343.jpg",
                        title: "亚利桑那冰茶680mlx24绿茶",
                        price: 289.00,
                        id: 178162
                    }, {
                        image: "https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/shop/2021-06-02/c2feb0e3d9fc071b22204ee52dd335ed.jpg",
                        title: "屈臣氏苏打水330mlx24香草",
                        price: 92.00,
                        id: 8761
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220516/64d659f60ef822f813abc87eddf4fd2b.jpg",
                        title: "芳塔娜果汁1Lx12",
                        price: 173.00,
                        id: 178168
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220516/0fb2962ee600cba26c950fd1deddf3fe.jpg",
                        title: "可口可乐 零度可乐无糖汽水500mx24瓶",
                        price: 59.00,
                        id: 178175
                    }, {
                        image: "https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/shop/2021-06-02/1f5ebe47a58f25ff2c8753489647d66d.png",
                        title: "农夫山泉 NFC果汁饮料 100%NFC橙汁300mlx24瓶 整箱装",
                        price: 151.00,
                        id: 8196
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220516/31ab5bff123f497bf5d6d583aa98d697.jpg",
                        title: "日本原装进口 三得利Gokuri 白桃果汁葡萄果汁饮料饮品 桃汁饮料400gx24瓶/整箱",
                        price: 349.00,
                        id: 178178
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220516/2d65b09b516b554057d866b96698578e.jpg",
                        title: "日本进口NECTAR网红高颜值不二家白桃汁水蜜桃果肉碳酸果汁饮料25%人气气泡饮品 25%白桃汁 24瓶装",
                        price: 299.00,
                        id: 178187
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2021/05/20210524/380ed29f2d76499bc5081cc78591e5ca.jpg",
                        title: "椰树牌椰子汁245mlx24罐",
                        price: 108.00,
                        id: 7054
                    }, {
                        image: "http://gzh.xiaojiangwh.com/uploads/attach/2020/04/20200423/b5a79f8fecdf4c77e660a1ec3cc3962c.jpg",
                        title: "德国 爱士堡 小麦白啤酒500ml*24听 整箱装",
                        price: 138.00,
                        id: 29
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220516/476eb359135e6e653e08029515727a15.jpg",
                        title: "燕京 特制啤酒 整箱 330ml*24罐",
                        price: 81.00,
                        id: 178188
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220516/7a6411f94bb06441c058e5cc6306d005.jpg",
                        title: "乌苏啤酒 红乌苏罐啤酒 500ml*12罐",
                        price: 79.90,
                        id: 178189
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2021/07/20210712/a0805078fafe0dd479e2369f84bbaf07.jpg",
                        title: "燕京啤酒 8度 U8小度酒 500mlx12听",
                        price: 72.00,
                        id: 21801
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220516/14f03f33e07d2594867166fdf0f679ed.jpg",
                        title: "萨罗娜 小麦白啤酒 500ml*24听整箱装",
                        price: 58.00,
                        id: 178190
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220516/2b1df7f255f99f71db1e02dd73ebdb4d.jpg",
                        title: "朝日啤酒500mlx24",
                        price: 178.00,
                        id: 178200
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220516/095a284a197c57370caf90bca091511e.jpg",
                        title: "风花雪月啤酒325mlx24",
                        price: 199.00,
                        id: 178205
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220516/7f769393508bab8605a9706e16d94f9f.jpg",
                        title: "国产福佳（Hoegaarden）小麦白啤酒 福佳白 精酿啤酒 330mlx24瓶",
                        price: 218.00,
                        id: 178211
                    }
                    ]
                }, {
                    id: 2,
                    titleInfo: require("@assets/images/summer-title2-1.png"),
                    list: [
                    {
                        image: "http://gzh.xiaojiangwh.com/uploads/attach/2021/06/20210611/bae07030512ab8f4b4730d7ff106b2fe.jpg",
                        title: "同仁堂菊花（贡菊）50g/ 瓶",
                        price: 55.00,
                        id: 177337
                    }, {
                        image: "http://gzh.xiaojiangwh.com/uploads/attach/2021/06/20210611/2cd2434e55dc4a999205ebeb2ec43e17.jpg",
                        title: "同仁堂玫瑰花80g/瓶",
                        price: 48.00,
                        id: 177338
                    }, {
                        image: "http://gzh.xiaojiangwh.com/uploads/attach/2021/06/20210611/466044838ce93351faa15b3c9944d795.jpg",
                        title: "同仁堂百合150g/瓶",
                        price: 64.00,
                        id: 177339
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2021/07/20210713/1743214a3ea967b7e38b946c46594574.jpg",
                        title: "同仁堂金银花50g/瓶",
                        price: 64.00,
                        id: 7068
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/bea95b025a1e63b594942f91f1412b21.jpg",
                        title: "茶里桂花乌龙54g(3gx18）",
                        price: 59.00,
                        id: 178123
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/2dca6a23fd506a650ace67e7ec4e79a6.jpg",
                        title: "茶里陈皮普洱 54g(3gx18)",
                        price: 59.00,
                        id: 178124
                    }, {
                        image: "https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/shop/2021-06-02/70b022236689d7267178a995258883de.png",
                        title: "茶里 ChaLi 每日茶礼盒蜜桃乌龙桂花红茶玫瑰花果味茶包袋泡办公用茶下午茶企业用茶冷泡茶63.5g 21包",
                        price: 80.00,
                        id: 7828
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/c1cb8c5722299f86bc2c49a5f52eb121.jpg",
                        title: "云耕物作云露玫瑰35g/盒",
                        price: 56.00,
                        id: 178125
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2021/05/20210511/9dda65bbffb017ba2d4f4d3a1090e808.jpg",
                        title: "中国香港 美心(Meixin) 原味鸡蛋卷礼盒 团购大礼包福利送礼品 448g",
                        price: 159.00,
                        id: 6742
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/1751e7d4aaf1e9e2b2c1234e6f8bb775.jpg",
                        title: "轩妈家蛋黄酥4种口味混合各种组合装 发两盒",
                        price: 119.00,
                        id: 169717
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/8f68f65e74c28cfc693511640fa69c9e.jpg",
                        title: "榴芒一刻 榴莲饼200gx2袋装",
                        price: 32.00,
                        id: 177861
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220510/cf105c13ac625423c2d20aca0891e2e6.jpg",
                        title: "姚生记500克姚小鲜每日坚果/桶装",
                        price: 72.00,
                        id: 177865
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220516/49850dd0046e7cc4ed344056f82c21e9.jpg",
                        title: "荷美尔轻享薄切牛肉干（一抹咸香）35gx6",
                        price: 138.00,
                        id: 178131
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/02/20220217/ec406756fc3eaa1eb1de1a0aaba96bf1.jpg",
                        title: "王小卤虎皮凤爪卤香 200gx2袋",
                        price: 58.00,
                        id: 177284
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220511/47737c3f717e08c67b2a1e8f020d9ddf.jpg",
                        title: "伊利安慕希高端畅饮型希腊风味酸奶原味230gx10",
                        price: 78.00,
                        id: 177870
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220518/21748979b84600b16e30b7b3e09a32ba.jpg",
                        title: "MR CAFE咖啡先生® 马来西亚特浓金典即溶咖啡mc06",
                        price: 59.00,
                        id: 178372
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220518/95d789222c8aaafcb5d7aa5edd6b6ae9.jpg",
                        title: "MR TEA奶茶先生® 3合1即溶奶茶mc08",
                        price: 42.00,
                        id: 178373
                    }, {
                        image: "https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/shop/2021-06-02/960c89f4fe7ad753b270d63eb3e84c0c.jpg",
                        title: "伊利金典有机纯牛奶梦幻盖 250mlx10盒",
                        price: 75.00,
                        id: 10350
                    }, {
                        image: "http://gzh.xiaojiangwh.com/uploads/attach/2020/09/23/632db2d1c3742f316d6cc694174dd9ef.jpg",
                        title: "蒙牛 特仑苏有机纯牛奶250mlx10盒",
                        price: 78.00,
                        id: 155
                    }, {
                        image: "https://image.dongfangfuli.com/mall/upload/image_temp/2020-07/496ae72b-1ce5-42d3-962b-1286616b70d2.jpg",
                        title: "德亚 法国有机牧场有机纯牛奶 200mlx10盒装",
                        price: 87.00,
                        id: 4660
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220516/433f8592505a1d458f8dcc19627a925b.jpg",
                        title: "新西兰原装进口 安佳（Anchor）低脂高钙纯牛奶 草饲奶源 营养早餐牛奶 减少50%脂肪 1Lx12盒/箱 整箱装",
                        price: 129.00,
                        id: 178132
                    }, {
                        image: "https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/005dff22278bf19a3611d4f3f1d14608.jpg",
                        title: "【澳牧纯牛奶】原装进口澳牧A2β酪蛋白纯牛奶250mlx12盒",
                        price: 125.00,
                        id: 169666
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220516/3a7028999ec8bcb2be4faadfe60f895d.jpg",
                        title: "澳牧高端原装进口酸奶200mlx12盒",
                        price: 109.00,
                        id: 178133
                    }
                    ]
                }, {
                    id: 3,
                    titleInfo: require("@assets/images/summer-title3-1.png"),
                    list: [
                    {
                        image: "https://xiaojianggzh.oss-cn-beijing.aliyuncs.com/0800b202112102205492078.jpg",
                        title: "欧舒丹5合1草本菁纯修护洗护发礼盒（洗发水500ml+护发素500ml）",
                        price: 595.00,
                        id: 177297
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2021/10/20211025/28d92378ab652f0f8e05713ae031ba1d.jpg",
                        title: "欧舒丹护手霜套装3支装(乳木果30ml+玫瑰30ml+樱花30ml)",
                        price: 270.00,
                        id: 169543
                    }, {
                        image: "http://gzh.xiaojiangwh.com/uploads/attach/2021/02/20210226/da6928521d465cde68b6605135c79058.jpg",
                        title: "欧舒丹·乳木果洁肤皂套装3块装（牛奶味100g+薰衣草味100g+马鞭草100g）",
                        price: 180.00,
                        id: 177305
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/178dc7cc53efe1231fdaa0a5e5d090e7.jpg",
                        title: "Amino mason氨基研洗发水+护发素 450ml",
                        price: 258.00,
                        id: 178097
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/02/20220217/f12a7374ba8ea4f23ef879ccb3f1fdd3.jpg",
                        title: "pola洗发水540g，护发素540g套装",
                        price: 428.00,
                        id: 177247
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/02/20220217/e6c22a2faada4dd26302a518960ecc6c.jpg",
                        title: "可悠然奢宠美肌沐浴露（蜜恋馨语）400ml",
                        price: 86.00,
                        id: 177244
                    }, {
                        image: "http://gzh.xiaojiangwh.com/uploads/attach/2021/03/20210304/c5a4af7c71b2da1c4c1d79867c27fbba.jpg",
                        title: "惠百施（EBISU）·日本进口48孔/41经典宽头牙刷成人软毛牙刷 4支",
                        price: 99.00,
                        id: 177300
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2021/05/20210525/5d3113957448f696af63c116de4db376.jpg",
                        title: "花王防蛀美白牙膏165gx3支",
                        price: 39.00,
                        id: 177299
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/aa405f4a48ee293ec4870fea01559c3e.jpg",
                        title: "蒲地蓝强健口腔牙膏120g",
                        price: 49.00,
                        id: 178098
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/856d39358cdce49f61316d882e34dd44.jpg",
                        title: "蒲地蓝可炎宁 抑菌含漱液260ml",
                        price: 49.00,
                        id: 178099
                    }, {
                        image: "http://gzh.xiaojiangwh.com/uploads/attach/2021/02/20210226/78fbe51cdd31c90cafd4d50a9638b380.jpg",
                        title: "舒客·专研酵素美白牙膏120g×2支（新老包装随机发货）",
                        price: 52.00,
                        id: 177306
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2021/05/20210525/b207cf778d40d68d06f770ee460e848f.jpg",
                        title: "蓝月亮 亮白增艳洗衣液3kg*2",
                        price: 89.00,
                        id: 7094
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/8c079c88899c8a4d0950c93a8de123a2.jpg",
                        title: "蓝月亮2kg洁净薰+1kg洁净薰瓶+1kg洁净薰袋+500g手洗翻盖x2",
                        price: 99.00,
                        id: 178100
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/02/20220217/058ae402081711932f29aac9913d7b50.jpg",
                        title: "牛乳石硷 COW 牛乳石碱美肤沐浴乳（淡雅花香） 500ml（ 滋润肌肤 绵密泡泡）牛奶沐浴露日本进口牛牌",
                        price: 58.00,
                        id: 177249
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2021/04/20210415/aa2bd707a0f892a209deae7d33826bb3.png",
                        title: "资生堂泊美 鲜纯多效植物精华油面膜14片",
                        price: 109.00,
                        id: 6596
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220516/7de3479e927375b59e5ec9fce4495c76.jpg",
                        title: "洁丽雅 Grace 棉柔巾居家差旅便携洁面巾 干湿两用 一次性洗脸毛巾 擦脸巾珍珠纹款 6包 20x20cm 60片/包",
                        price: 68.00,
                        id: 178230
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/02/20220217/6b9bc6d547fd8e004fdc02c06523630e.jpg",
                        title: "资生堂珊珂 绵润白泥泡沫洁面乳 120g*2",
                        price: 92.00,
                        id: 177251
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2021/05/20210525/9eb2892b27673288b4345ab80abf502f.jpg",
                        title: "未来vape150晚驱蚊器",
                        price: 99.00,
                        id: 7082
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/706a86c25937d7be51c2f6af587ab71c.jpg",
                        title: "日本 金鸟驱蚊手环 蓝色",
                        price: 42.00,
                        id: 178101
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/c3e57e33926ed4a0945f7eab5f331cd6.jpg",
                        title: "日本 成人无比滴止痒液凝露清凉消肿舒缓液50mlx2",
                        price: 78.00,
                        id: 178102
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/209b46f119acb4d1d1e67fec74dd9d3e.jpg",
                        title: "日本 未来驱蚊喷雾驱蚊喷雾 蓝色柑橘味 200ml",
                        price: 49.00,
                        id: 178103
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/a5a3bdd6cb29f695a91e7b2c11503649.jpg",
                        title: "日本碧柔爽肤止汗冷感降温湿巾 花香 20片x2",
                        price: 89.00,
                        id: 178104
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/02/20220217/2955b74d0757919a3fbb701a5114f7df.jpg",
                        title: "花王洗洁精（香型随机） 240ml*3",
                        price: 59.00,
                        id: 177343
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/02/20220217/ced102cbb3f098b1e88cad4de3db9136.jpg",
                        title: "花王洗衣液780gx2",
                        price: 69.00,
                        id: 177289
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/74d8700f997b5a86eeedec6534b0df5c.jpg",
                        title: "日本 小鸡小白鞋运动鞋增白清洁剂 240mL",
                        price: 39.00,
                        id: 178107
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/ee68397ae5cdf2c6513640d92401dc6e.jpg",
                        title: "韩国红吕洗发水400ml（中标）x2",
                        price: 106.00,
                        id: 178108
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/486d7b3c982d7f3a0adfff8e67589b34.jpg",
                        title: "资生堂 可悠然美肌沐浴露 碧野悠悠 绿色550ml",
                        price: 59.00,
                        id: 178109
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/02/20220217/5eb03107ed902676362e6fa97d89b871.jpg",
                        title: "花王（KAO）日本进口油烟机清洗剂油污清洁剂 去油污厨房清洁剂油污净泡沫清洗剂 400ml",
                        price: 39.00,
                        id: 177291
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/02/20220217/5c7f6dc6f5281e8c7322fb7876959ba0.jpg",
                        title: "日本花王（KAO）马桶清洁剂洁厕液 免刷洗强效去污垢除异味清洗剂洁厕剂洁厕灵 500ml",
                        price: 45.00,
                        id: 177265
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/02/20220217/812041798ad0d9d0344c8e0bbb48854f.jpg",
                        title: "日本花王（KAO）强力除霉泡沫清洁喷剂（浴室）浴室清洁剂400ml",
                        price: 48.00,
                        id: 177292
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/02/20220217/300ad8cfc99540b3331758c2f76ea51a.jpg",
                        title: "花王洗衣机清洗剂180g日本原装进口洗衣机槽除异除垢清洁剂去污粉",
                        price: 35.00,
                        id: 177266
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/06f46548518f524140151d9c2cc3b366.jpg",
                        title: "得宝卫生湿巾12片/包x10",
                        price: 49.00,
                        id: 178110
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/67b5257d68c8085d8e6d8ca3d2176cb0.jpg",
                        title: "日本 花王儿童碧柔泡沫洗手液无香型 250ml",
                        price: 38.00,
                        id: 178111
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/ad8ba361efa11026cb5d2e4d90496ca3.jpg",
                        title: "资生堂Shiseido 安热沙水能户外轻透防晒乳60ml（小金瓶）",
                        price: 236.00,
                        id: 178112
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/b15722dde3a4c9a4869637a14d2cac76.jpg",
                        title: "资生堂Shiseido 安热沙水能户外防晒喷雾60g",
                        price: 139.00,
                        id: 178113
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/3939e5c2c32b7e52b78a21e4be118ed9.jpg",
                        title: "兰芝LANEIGE 雪纱丝柔防晒隔离乳40号 30ml（紫隔离）",
                        price: 189.00,
                        id: 178114
                    }, {
                        image: "https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/shop/2021-06-04/bb4df44bd11aa1de40fe55fecaef9cf0.jpg",
                        title: "雅漾舒泉调理喷雾300ml",
                        price: 111.00,
                        id: 15236
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/a71645e3be90fb2a63fbd6aa011d17ad.jpg",
                        title: "玫珂菲MUF 保湿持妆喷雾 100ml 控油",
                        price: 260.00,
                        id: 178117
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/607cde23f0581a5b8951466577f08259.jpg",
                        title: "韩国 JMSOLUTION 珍珠防晒喷雾防晒霜 SPF50+ PA++++ 180ML",
                        price: 67.00,
                        id: 178119
                    }, {
                        image: "http://gzh.xiaojiangwh.com/uploads/attach/2021/02/20210227/a94608f65b8894501f01bb55288157f0.png",
                        title: "娜丽丝·防晒喷雾粉色90g",
                        price: 69.00,
                        id: 177308
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/02/20220217/2df44bff4e1f921de8d42a0de1c6fb04.jpg",
                        title: "ITO抽取式洁面巾 60片 3包",
                        price: 49.00,
                        id: 177260
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2021/12/20211220/95957b2187eea9b4ced99cebf1993865.jpg",
                        title: "玉泽积雪草安心修护面膜盒装（6片，有盒子、量杯）",
                        price: 89.00,
                        id: 170131
                    }, {
                        image: "http://test.xiaojiangwh.com/uploads/attach/2022/02/20220217/9b7a9492a9e1e2136f525bce06f6b3f0.jpg",
                        title: "蒂佳婷 水动力活力水润面膜25g/5p（蓝药丸）",
                        price: 99.00,
                        id: 177250
                    }
                    ]
                }, {
                    id: 4,
                    titleInfo: require("@assets/images/summer-title4-1.png"),
                    list: [
                        {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220507/a10baf987272e2776a1c5ca39e85a347.jpg",
                            title: "翼眠无压枕-波浪款",
                            price: 235.00,
                            id: 177532
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220507/142ae183cde9a2515ee647b0e6cc60f0.jpg",
                            title: "磨客mokkom即热式开水机  MK-371",
                            price: 498.00,
                            id: 177536
                        }, {
                            image: "https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/shop/2021-06-07/b85b222b59565daa8720e215823d578d.jpg",
                            title: "SKG颈椎按摩仪K3 灰色",
                            price: 256.00,
                            id: 19172
                        }, {
                            image: "https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/shop/2021-06-07/08f9de58b11c209853e8b9f5b04521d9.jpg",
                            title: "SKG Mini筋膜枪 F5 白色",
                            price: 500.00,
                            id: 19168
                        }, {
                            image: "https://image.dongfangfuli.com/supplier/d71b8bf03646468f8a10c3e41d7795d8.jpg",
                            title: "大宇（DAEWOO） 折叠折叠蒸汽烫机 HI-029",
                            price: 364.00,
                            id: 5171
                        }, {
                            image: "http://gzh.xiaojiangwh.com/uploads/attach/2021/08/20210810/4918c7a58a3227a02c8ab1b3a07340f4.jpg",
                            title: "大宇（DAEWOO） 自动洗手机套装 HS01",
                            price: 186.00,
                            id: 177334
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220507/8999cec43f97fea64fd84d00e3b66693.jpg",
                            title: "小米生态企业90分反向自动折叠雨伞LED灯照明伞",
                            price: 89.00,
                            id: 177566
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220507/c948cde5853b906222ede858871e9039.jpg",
                            title: "素乐立式灭蚊灯电蚊拍P1",
                            price: 79.00,
                            id: 177573
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220507/c953b8c1deef56674d4dfd309138db85.jpg",
                            title: "九阳 空气炸锅家用多功能3L大容量KL30-VF165",
                            price: 368.00,
                            id: 177576 
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220507/13088fd3b6056808ab73b3b83b450d9c.jpg",
                            title: "康宁玻璃保鲜盒1040ML/1000ML",
                            price: 168.00,
                            id: 177579
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220507/0bcd3e05db0aa8dc34a58699517e4fe4.jpg",
                            title: "BRUNO空气炸锅BZK-KZ02",
                            price: 519.00,
                            id: 177580
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220507/7fe358b6870ac93b99ef6561546b0b0a.jpg",
                            title: "BRUNO冰激凌机BZK-B01",
                            price: 499.00,
                            id: 177583
                        }, {
                            image: "http://gzh.xiaojiangwh.com/uploads/attach/2021/06/20210616/a589abd5b8542c5dca7e044254436744.jpg",
                            title: "摩飞榨汁杯MR9800",
                            price: 178.00,
                            id: 177328
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220507/d89e3f83f8f608b65a29167697fa9769.jpg",
                            title: "摩飞蒸汽挂烫机MR2031椰奶白",
                            price: 309.00,
                            id: 177592
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220507/cc33cc0180135a1c54d92c447dbfd486.jpg",
                            title: "摩飞多功能锅MR9088绿色",
                            price: 789.00,
                            id: 177595
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220507/a17d4126abef8355d34469dec8f4559e.jpg",
                            title: "莱克吉米除螨机B503",
                            price: 639.00,
                            id: 177600
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220507/43b7360c75f2ff5bf00dde8a416497e3.jpg",
                            title: "鲨客洗地机T31",
                            price: 1599.00,
                            id: 177606
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220507/7769e359adda28408e486634c6f19696.png",
                            title: "Apixintl安本素多功能款蒸汽拖把 ZQ-W09",
                            price: 569.00,
                            id: 177610
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220507/0dc2bff0da7d53195d3a5d1273c657f4.jpg",
                            title: "素士复古负离子电吹风RH1 原野绿 标准版 （无按摩风嘴）",
                            price: 328.00,
                            id: 177641
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2021/05/20210512/58ba61170e0bcfd1a2f1b56179da23ca.jpg",
                            title: "素士声波电动牙刷X3U 麦田群鸦",
                            price: 288.00,
                            id: 6825
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2021/05/20210513/fcf68f3f086c773dbb268c3532c141e9.jpg",
                            title: "素士凌朗S31顺滑型电动剃须刀",
                            price: 235.00,
                            id: 6898
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220507/408ee3dbea0e3238adfdda9a81bcaa26.jpg",
                            title: "直白冷风卷发棒VL6绿色",
                            price: 369.00,
                            id: 177644
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220507/0ac7190f1e4421152a3864e144b0a9d7.jpg",
                            title: "极简风手动剃须刀德国进口5层刀片八件套 H300-8",
                            price: 159.00,
                            id: 177645
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220507/306bf3a2048c8f065169e2d099775dbc.jpg",
                            title: "心想 即热饮水机抗菌低噪版S2305（颜色随机）",
                            price: 559.00,
                            id: 177646
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2021/05/20210513/e471b21916f36ab04dc99c9247be2158.jpg",
                            title: "美的 自动感应洗手机免洗款 智能感应出泡OXS-2800",
                            price: 109.00,
                            id: 6915
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220507/8d1581246bed38b96073112858c922fe.jpg",
                            title: "倍轻松（breo)头部按摩器 Scalp Mini 小鸡彩虹联名款",
                            price: 428.00,
                            id: 177647
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/02/20220217/848cd24464a063207994cfb0d6e5ecda.jpg",
                            title: "野小兽智能跳绳 SR5S 白色",
                            price: 99.00,
                            id: 177273
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220507/31243cfbae4fadb22ed33e93a4124495.jpg",
                            title: "野小兽智能呼啦圈HL20 M码",
                            price: 219.00,
                            id: 177649
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/02/20220217/18edd53704fec4f73a5e1bf1803c8d51.jpg",
                            title: "凯速加厚防滑环保瑜伽垫拉力器健身套装",
                            price: 69.00,
                            id: 177277
                        }, {
                            image: "http://app.qianbaishikeji.com/qbs_server/upload/resimgs/1/4260/31929/img300.jpg",
                            title: "HOYO 1689 抗菌运动巾橡木礼盒毛巾单条装",
                            price: 85.00,
                            id: 172569
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220507/3c58da06aa5d5c1c96ae82ecb6645e86.jpg",
                            title: "Maki zaza四人单层野营速开帐篷MKZ-002",
                            price: 164.00,
                            id: 177650
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220507/e05dbc0cbc3cee77d114befa1ef1fe14.jpg",
                            title: "Maki zaza单人帆布加厚吊床MKZ-012",
                            price: 50.00,
                            id: 177651
                        }, {
                            image: "https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/shop/2021-06-07/c576ab79a7e3621446052d757f1d5a32.jpg",
                            title: "外交官多功能地垫DFJ-301",
                            price: 137.00,
                            id: 20515
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/62db99aa632fcf344d0abfd74d1211b2.jpg",
                            title: "Maki zaza户外折叠桌椅四件套MKZ-016",
                            price: 229.00,
                            id: 178079
                        }, {
                            image: "https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/0d79425b7ebb296d54bcfc9b19cf6d52.jpg",
                            title: "匹克游泳套装YS301022010140101",
                            price: 199.00,
                            id: 21786
                        }, {
                            image: "http://app.qianbaishikeji.com/qbs_server/upload/resimgs/1/8482/66406/img300.jpg",
                            title: "匹克（PEAK）YY41310羽毛球拍套装",
                            price: 128.00,
                            id: 175744
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220516/a601e5d81a40d029a871b1f80e3255b1.jpg",
                            title: "李宁ELITE比赛篮球LBQK887-3（7号）",
                            price: 246.00,
                            id: 178237
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220512/92cd52f7f605428d59562e4ea3bfe701.jpg",
                            title: "华米Amazfit 专业运动系列智能运动手表",
                            price: 599.00,
                            id: 178028
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/0262fc2404b41d747d23366cd9205313.jpg",
                            title: "YESOUL野小兽M1智能动感单车（刘涛代言，明星同款",
                            price: 1299.00,
                            id: 178080
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220512/586db7b8061a2e721ce1d9810897f6fe.jpg",
                            title: "美的折叠洗衣机臭氧款MX-ZDXG01",
                            price: 459.00,
                            id: 178029
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220512/a0201032da05a9157ce0b11cd220274e.jpg",
                            title: "艾美特桌夹扇 AH10",
                            price: 114.00,
                            id: 178030
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220512/06097787a93d69ce4873c494af4aeea6.jpg",
                            title: "日本amadana 3D台式空气循环扇A-FC015DR富士白",
                            price: 369.00,
                            id: 178031
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/79f2c48ad502f35c74477ade71c4b849.jpg",
                            title: "几素多功能收纳折叠风扇F8（2000mAh）白色",
                            price: 54.00,
                            id: 178081
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/b7269526fc3cf7faf7688ac1cc2ef765.jpg",
                            title: "几素涡轮无叶挂脖风扇FA12（4000mAh）灰色",
                            price: 139.00,
                            id: 178086
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/bc27a9a16abd8f154efdd2ec93fa9723.jpg",
                            title: "SK空气净化无叶风扇SKJ-CR021（低配款",
                            price: 600.00,
                            id: 178091
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220512/3f36e37ca4631637fe33e2b957bed86b.jpg",
                            title: "斗禾空调加湿风扇DH-KTS04L",
                            price: 209.00,
                            id: 178032
                        }, {
                            image: "https://image.dongfangfuli.com/mall/upload/image_temp/2020-05/86475ed8-043b-4ce8-911a-bb767961d196.jpg",
                            title: "斗禾 除湿机 家用小型抽湿机 卧室除湿器 干燥机 吸湿器 迷你去湿器神器 DH-CS01",
                            price: 293.00,
                            id: 2895
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/4452bb787058d9818f5a57e33d0bb016.jpg",
                            title: "蕉下-零触系列防晒袖套（男女同款）颜色随机",
                            price: 69.00,
                            id: 178093
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220512/48c1395636ea87c11916259a9ffd6ad2.jpg",
                            title: "蕉下-冰薄系列护眼角防晒口罩（颜色随机）",
                            price: 60.00,
                            id: 178033
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220512/1245a011d2e291157c370caa072f3fd9.jpg",
                            title: "蕉下-冰薄系列披肩防晒服（均码）（颜色随机",
                            price: 181.00,
                            id: 178034
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220512/bdfc2e901e7280c570e0cd1c456918c7.jpg",
                            title: "蕉下2022年-果趣系列（国潮系列）三折伞夏日顶榴",
                            price: 186.00,
                            id: 178035
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/c11e7850665ab511bb21988c0b89de25.jpg",
                            title: "鸣盏速冷保冷杯 MZ-8009",
                            price: 164.00,
                            id: 178094
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/bbf08b8dfbd5f0fda818b19e4e69f1c9.jpg",
                            title: "康佳驱蚊器KQW01",
                            price: 89.00,
                            id: 178095
                        }, {
                            image: "http://test.xiaojiangwh.com/uploads/attach/2022/05/20220513/5197cac814e924969ed09731bc4569d7.jpg",
                            title: "漫步者Lolli Pod Pro 真无线立体声降噪耳机",
                            price: 346.00,
                            id: 178096
                        }, {
                            image: "https://xiaojiangshop.oss-cn-beijing.aliyuncs.com/shop/2021-06-07/b5d54306d81f948ec1de03125bb9a252.jpg",
                            title: "外交官自开收晴雨伞DFJ-605",
                            price: 99.00,
                            id: 20485
                        }
                    ]
                }
            ],
            navTop: null,
            scrollbar: null,
            leaveScroll: 0,
            current: "" //nav当前id
        }
    },
    mounted: function () {
        let dom = this.$refs.five;
        this.getData();
        dom.addEventListener("scroll", debounce(this.onScroll, 20), false);
    },
    updated: function () {
        this.getDom();
    },
    methods: {
        goBack() {
            this.$router.push('/');
        },
        goTo() {
            const dom = this.$refs.five;
            dom.scrollTo(0, 0);
            this.mounting = false;
            this.current = this.list[0].id;
        },
        checkNav: function (id) {
            // console.log(id, "nav");
            if (id == this.current) return;
            this.current = id;
            const dom = this.$refs.five;
            for(let i=0; i < this.list.length; i++ ) {
                if (id == this.list[i].id) {
                    dom.scrollTo(0, this.list[i].top);
                }
            }
        },
        onScroll: function (e) {
            let scrol = e.target.scrollTop;
            // console.log(scrol,"监听滚动条", this.navTop);
            this.scrollbar = scrol;
            if (this.navTop && scrol >= this.navTop) { // nav
                this.mounting = true;
            } else {
                this.mounting = false;
            }

            this.list.forEach((item)=>{
                if (item.totalHeight >= scrol && scrol >= item.top) {
                    // console.log(item.top,"top", item.totalHeight);
                    this.current = item.id;
                }
            });
        },
        getData: function () {
            //获取数据
            this.current = this.list[0].id;
            //this.$nextTick(()=>)↓
            // this.$nextTick(()=> this.getDom())
            
        },
        getDom: function () {
            // console.log(this.$refs.modul1.offsetHeight, "height")
            this.list.forEach((item)=>{
                item.top = this.$refs[`modul${item.id}`] && this.$refs[`modul${item.id}`][0] && this.$refs[`modul${item.id}`][0].offsetTop;
                item.totalHeight = (this.$refs[`modul${item.id}`] && this.$refs[`modul${item.id}`][0] && this.$refs[`modul${item.id}`][0].offsetTop) + this.$refs[`modul${item.id}`][0].offsetHeight;
            });
            this.navTop = this.$refs.nav.offsetTop;
            // this.navTop = 525;
            // console.log(this.list,"this.list");
        }
    },
    deactivated: function () {
        // let dom = this.$refs.five;
        // dom.removeEventListener("scroll", this.onScroll);
    },
    activated: function () {
        const dom = this.$refs.five;
        dom.scrollTo(0, this.scrollbar);
    },
    beforeRouteLeave: function (to, from, next) {
        this.leaveScroll = this.scrollbar;
        next();
    }
}
</script>

<style scoped>
.banner-wrapper {
    height: 11.43rem;
}
.festivalList-wrapper {
    height: auto;
    /* margin: 0 auto; */
    margin-top: -0.5rem;
    background: url("../../assets/images/summer-banner.png") no-repeat;
    background-size: 100% 100%;
}
.nav-content-title-wrapper {
    height: .8rem;
}
.mounting {
    position: fixed;
    top: 0;
    left: 0;
}
.nav-wrapper {
    height: 1rem;
}
.marTop {
    margin-top: 1rem;
}
.got {
    bottom: 1.2rem;
    left: 50%;
    transform: translate(-50%, 0);
    width: 2.6rem;
    height: auto;
}
.goTop {
    width: 1.3rem;
    height: auto;
    bottom: 4%;
    right: 0.2rem;
    z-index: 100;
}
</style>